import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import axiosInstance from "api/axiosInstance";

const PrivateRoute = ({ children }) => {
  const [isAuthenticated, setIsAutheticated] = useState(null);

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem("token");

      if (!token) {
        setIsAutheticated(false);
        return;
      }

      try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        if (decodedToken < currentTime) {
          const response = await axiosInstance.post("/auth/refresh-token");
          localStorage.setItem("token", response.data.token);
          setIsAutheticated(true);
        } else {
          setIsAutheticated(true);
        }
      } catch (error) {
        console.error("Invalid or expired token", error);
        localStorage.removeItem("token");
        setIsAutheticated(false);
      }
    };

    checkAuth();
  }, []);

  if (isAuthenticated === null) {
    return <div className="text-white text-center mt-10">Loading...</div>;
  }

  return isAuthenticated ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
